import ListeCollecte from '@/components/collecte/ListeCollecte';

export default [
    {
        path: '/liste-collecte',
        name: 'collecte',
        component: ListeCollecte
    }
]